import * as React from 'react';
import * as styles from './AsideBuilderContacts.css';

interface IAsideBuilderContactsProps {
  actionButton: React.JSX.Element;
  messageButton: React.JSX.Element;
  workTimeInfo: React.JSX.Element;
}

export const AsideBuilderContacts: React.FC<IAsideBuilderContactsProps> = ({
  actionButton,
  messageButton,
  workTimeInfo,
}) => {
  return (
    <div className={styles['aside-builders-contacts']}>
      <div className={styles['buttons']}>
        <div className={styles['action-button']}>{actionButton}</div>
        <div className={styles['message-button']}>{messageButton}</div>
      </div>
      {workTimeInfo}
    </div>
  );
};
